import { TenantVM } from "@propertelligent/client-api";

type TenantWithPastDue = TenantVM & { pastDue?: number };

export type TenantDueHighlight = {
  isPastDue: boolean;
  formatted?: string;
  raw?: string;
};

// Past Due = outstanding tenant dues with DueDate before today (TenantVM.PastDue), not IncomeDue,
// which also includes current and future dues.
export const getTenantPastDue = (tenant?: TenantVM | null): number =>
  Number((tenant as TenantWithPastDue | null | undefined)?.pastDue ?? 0);

// The "Past Due" label applies only to overdue amounts; current/future dues still show the
// outstanding amount (IncomeDue) without the label.
export const getTenantDueHighlight = (
  tenant?: TenantVM | null
): TenantDueHighlight | null => {
  if (!tenant) return null;
  if (getTenantPastDue(tenant) > 0) {
    return {
      isPastDue: true,
      formatted: tenant.formatted?.PastDue,
      raw: tenant.formatted?.PastDueRaw,
    };
  }
  if (Number(tenant.incomeDue ?? 0) > 0) {
    return {
      isPastDue: false,
      formatted: tenant.formatted?.IncomeDue,
      raw: tenant.formatted?.IncomeDueRaw,
    };
  }
  return null;
};
